import type { AppEnv } from './environment.default';
import { ENVIRONMENT, environment as defaultEnv } from './environment.default';

export const environment: AppEnv = {
  ...defaultEnv,
  ENV: ENVIRONMENT.development,
  AUTH_CLIENT_ID: 'e1988e49-f80e-48da-9293-9559b7eac34f',
};
